import React from 'react';
import DepartmentList from '../../components/Departments/DepartmentList';

const Departments = () => {
  return <DepartmentList />;
};

export default Departments;


